import React, { Component } from "react";

export default class SubModuleTile extends Component {
  render() {
    const { title, pathName, selectedPathName, hideTile } = this.props;

    return (
      <li
        className={selectedPathName === pathName ? "active" : ""}
        style={{
          display: hideTile ? "none" : "block",
        }}
      >
        <a href={pathName}>{title}</a>
      </li>
    );
  }
}
